module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-1-photo-10-cea12f4cbc423668b567674daabcbef1.webp";